import React from 'react';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';

//utils
import queries from '../../../utils/queries'

const ListaTC = ({handleListaT}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipo" id="miLista1" onChange={handleListaT}>
        <option>Comercial</option>
        <option>Técnico</option>
        <option>Laboratorio</option>
        <option>Administrativo</option>
        <option>Externo</option>
      </select>
    </div>
  )
}; 

const ListaHalla = ({handleListaH}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="gestionaHallazgos" id="miLista3" onChange={handleListaH}>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
  return (
    <option value={props.elemento._id}>{props.elemento.descrPerfil}</option>
  )
};

const Lista = ({styles, handleLista, listP}) => {
    const Nivel1Detalle = listP.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="perfil" id="miLista" onChange={handleLista}>
                <option value="">Seleccionar...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};

//Empresas
const DetalleNivelC = props => {
  return (
    <option>{props.elemento.descrEmpresa}</option>
  )
};

const ListaC = ({styles, handleListaC, listC}) => {
    const Nivel1Detalle = listC.map((elemento, _id) => <DetalleNivelC styles={styles} elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="descrEmpresa" id="miListaE" onChange={handleListaC}>
                <option value="">Todas...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};
//FIN Empresas

const DetalleNivelU = props => {
  return (
    <option>{props.elemento.nombreUsuario}</option>
  )
};

const ListaU = ({styles, handleListaU, listU}) => {
    const Nivel1Detalle = listU.map((elemento, _id) => <DetalleNivelU styles={styles} elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="suLider" id="miListaU" onChange={handleListaU}>
                <option value="">Seleccionar...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};

const ListaLider = ({handleListaL}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="esLider" id="miLista4" onChange={handleListaL}>
        <option>No</option>
        <option>Si</option>
      </select>
    </div>
  )
};

const AddUsu2 = ({styles, handleSubmit, handleListaT, handleLista, handleListaL, handleListaU, handleListaC, handleListaH, handleChange,
                  args, errors, list1, list2, data: {allPerfiles=[], props}}) => {

let estilos = Object.assign({}, styles.input, {cursor: 'pointer'})

  return(
        <div>
          <button className="ui right labeled icon button" style={styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              Usuario nuevo
          </button>
          <div style={styles.box}>
            <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
              <div className="ui three column stackable grid">
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Tipo de usuario</label>
                      <ListaTC styles={styles} handleListaT={handleListaT} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Correo electrónico</label>
                      <input type='email' autoComplete="off" name="email" id="email" onChange={handleChange} placeholder='Correo electrónico' icon={!errors.length?null: _find(errors, {path:'email'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Nombre del usuario</label>
                      <input autoComplete="off" name="nombreUsuario" id="nombreUsuario" onChange={handleChange} placeholder='Nombre del usuario' icon={!errors.length?null: _find(errors, {path:'nombreUsuario'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Cédula</label>
                      <input autoComplete="off" name="cedula" id="cedula" onChange={handleChange} placeholder='Cédula' icon={!errors.length?null: _find(errors, {path:'cedula'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>    
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>      
                    <Form.Field>
                      <label style={styles.label}>Clave de acceso</label>
                      <input autoComplete="off" name="claveDeAcceso" id="claveDeAcceso" onChange={handleChange} type='password' placeholder='Clave de acceso' icon={!errors.length?null: _find(errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Perfil</label>
                      <Lista listP={allPerfiles} handleLista={handleLista} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>                                <Form.Field>
                      <label style={styles.label}>Cargo</label>
                      <input autoComplete="off" name="cargo" id="cargo" onChange={handleChange} placeholder='Cargo' icon={!errors.length?null: _find(errors, {path:'cargo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Ciudad</label>
                      <input autoComplete="off" name="ciudad" id="ciudad" onChange={handleChange} placeholder='Ciudad' icon={!errors.length?null: _find(errors, {path:'ciudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Teléfono</label>
                      <input autoComplete="off" name="telefono" id="telefono" onChange={handleChange} placeholder='Teléfono' icon={!errors.length?null: _find(errors, {path:'telefono'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>     
                    <Form.Field>
                      <label style={styles.label}>Solo de la empresa</label>
                      <ListaC listC={list1} handleListaC={handleListaC} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Gestiona hallazgos</label>
                      <ListaHalla styles={styles} handleListaH={handleListaH} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%'}}>
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar imagen de firma...&nbsp;&nbsp;
                    </label>
                    <input id="file" name="file" type="file" accept="image/*" style={estilos} onChange={handleChange}></input>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>
                    <Form.Field>
                      <label style={styles.label}>Es lider ?</label>
                      <ListaLider styles={styles} handleListaL={handleListaL} />
                    </Form.Field>
                </div>
                <div className="column" style={{width: '33%', paddingTop: '0em'}}>     
                    <Form.Field>
                      <label style={styles.label}>Su lider es:</label>
                      <ListaU listU={list2} handleListaU={handleListaU} />
                    </Form.Field>
                </div>

                <Divider inverted />

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </Form>
          </div>
        </div>
    )
}

export default graphql(queries.query.allPerfiles)(AddUsu2)
